import { render, staticRenderFns } from "./CandidatesTabs.vue?vue&type=template&id=0b52cb86&lang=pug"
import script from "./CandidatesTabs.vue?vue&type=script&lang=js"
export * from "./CandidatesTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports